import React from 'react';
import Field from '../components/Field';

export default ({ fields, onChange }) =>
  fields.map(f => <Field {...f} key={f.name} onChange={onChange} />);
